<template>
  <div class="content">
    <div class="content-box">
      <div
        v-for="item in list"
        :key="item.code"
        class="box tab"
        @mouseenter="changeTag(item)"
        @click="titleDetail(item)"
        :style="
          item === target &&
          'border-bottom: 2px solid rgba(203, 180, 134, 1); color: #000;'
        "
      >
        <span :title="item.name">{{ item.name }}</span> 
      </div>
      <div>
        <div
          v-for="(item, index) in data"
          v-show="index < 4 &&target.contentECount > 1 && target.moduleClass == 'announce'"
          :key="item.contentCode"
          class="tab-box"
          @click="goDetail(item)"
        >
          <div class="tab-text">{{ item.contentTitle }}</div>
          <span class="tab-date" v-if="String(item.createTime).length === 10">{{
            item.createTime
          }}</span>
          <span class="tab-date">{{
            String(item.createTime).split(" ")[0]
          }}</span>
          <!--          <span class="tab-date">{{item.createTime}}</span>-->
        </div>
        <div
          class="design-html"
          v-show="
            (target.contentECount == 1 && target.moduleClass == 'announce') 
          "
          v-html="val"
          style="font-size: 12px; padding-top: 37px"
        ></div>
        <div
          class="design-html"
          v-show="
            target.moduleClass == 'contentpic'
          "
          style="font-size: 12px; padding-top: 37px"
        >
        <img :src="item" v-for="item,index in img" :key="index" alt="" class="img">
        <!-- <img class="img"  src="http://10.10.152.115/image/group1/M00/00/33/CgsAa2FtH-GAdqHjAAZV4CATQJk736.png?attname=foreign_enterprise_elegant1.png" alt="">
        <img class="img"  src="http://10.10.152.115/image/group1/M00/00/33/CgsAa2FtH-GAdqHjAAZV4CATQJk736.png?attname=foreign_enterprise_elegant1.png" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const list = [
//   { name: "外企风采", key: "qzxx", code: "RES6D2912437254887" },
//   { name: "外企招聘", key: "cjwt", code: "RES02919AC81B5C71C" },
//   { name: "联系方式", key: "lxfs" },
// ];
const data = [
  { title: "福州外商常驻代表机构办公场所", date: "2021-03-08" },
  { title: "外商驻榕机构雇员综合服务项目", date: "2021-03-08" },
  { title: "新增外企人力资源服务项目", date: "2021-03-08" },
  { title: "办理外籍人士就业入境邀请申请服务指南", date: "2021-03-08" },
];
import {
  getList,
  getStep,
  getInforTitle,
  getText,
  getInfo,
  getPic,
  getDetail,
} from "@/api/foreignCompanyService";
import {
 getFileDetails
} from "@/api/file";
export default {
  name: "choose-tab",
  data() {
    return {
      list: [],
      data,
      val: "",
      target: "",
      img:[]
    };
  },
  created() {
    this.changeTag();
    getInforTitle().then((res) => {
      res.data.records.forEach((e) => {
        this.list.push({
          name: e.moduleName,
          code: e.moduleCode,
          contentECount: e.contentECount,
          moduleClass: e.moduleClass,
        });
      });
      this.target = this.list[0] || "";
      this.getData();
    });
  },
  methods: {
    goDetail(item) {
      const type = "contentAnnounce";
      const name = this.list.find(item => item.code === this.target.code).name
      // getText(item.code).then((res) => {
      //   const data = this._.get(res, "data.records.0", {});
      this.pushRouter(
        `/guide?contentCode=${item.contentCode}&type=${type}&linkname=外企服务/+${name}+/详情`
      );
      // });
    },
    titleDetail(item) {
      if (item.contentECount > 1 && item.moduleClass == "announce") {
        this.pushRouter(
          `/announcement?moduleCode=${item.code}&type=contentAnnounce&name=${item.name}&&linkname=外企服务/${item.name}`
        );
      }
      if (item.contentECount == 1 && item.moduleClass == "announce") {
        getText(item.code).then((res) => {
          const data = this._.get(res, "data.records.0", {});
          this.pushRouter(
            "/guide?contentCode=" +
              data.contentCode +
              "&type=contentAnnounce&linkname=外企服务/" +
              data.contentTitle 
          );
        });
      }
    },
    getData() {
      this.list.forEach((e) => {
        if (
          e == this.target &&
          e.contentECount > 1 &&
          e.moduleClass == "announce"
        ) {
          this.img = []
          this.val = ""
  
          getList(e.code).then((res) => {
            this.data = this._.get(res, "data.records", []);
          });
          return;
        }
        if (
          e == this.target &&
          e.contentECount == 1 &&
          e.moduleClass == "announce"
        ) {
          this.img = []
          this.val = ""
       
          getText(e.code).then((res) => {
            const data = this._.get(res, "data.records.0", {});
            getInfo(data.contentCode).then((r) => {
              this.val = this._.get(r, "data.contentHtml", "");
            });
          });
          return;
        }
        if (e == this.target && e.moduleClass == "contentpic") {
          this.img = []
          this.val = ""
         
          getPic(e.code).then((res) => {
            const data = this._.get(res, "data.records", {});
            data.forEach(ele=>{
              getDetail(ele.picCode).then((re) => {
              re.data.contentPicFileDtoList.forEach(e=>{
                getFileDetails(re.data.appCode,re.data.tenantCode,[e.fileCode]).then((r)=>{
                  this.img.push(r.data[e.fileCode].fileHttpUrl)
                  // console.log(this.img)
                })
              })
            });
            })
            
            return;
          });
        }
      });
    },
    changeTag(val) {
      this.target = val;
      this.getData();
      // const mapObj = {
      //   qzxx: "RES6D2912437254887",
      //   cjwt: "RES02919AC81B5C71C",
      // };
      // if (mapObj[val]) {
      //   getList(mapObj[val], "", 4).then((res) => {
      //     this.data = this._.get(res, "data.records", []);
      //     // this.data = this.data.map((item) => {
      //     //   item.createTime = item.createTime.split(" ")[0];
      //     //   return item;
      //     // });
      //     console.log(this.data);
      //   });
      // } else {
      //   getStep("RESE3253BF4674F7CE").then((res) => {
      //     this.val = this._.get(res, "data.contentHtml", "");
      //   });
      // }
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  height: 384px;
  position: relative;
  margin: 0;
}
.content-box {
  width: 500px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  position: relative;
  margin: auto;
  text-align: left;
}
.box {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  margin-right: 45px;
  
}
.tab {
  width: 80px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-bottom: 40px;
  font-size: 20px;
 
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(188, 190, 192, 1);
  cursor: pointer;
}
.tab-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 28px 0 32px 15px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  position: relative;
  cursor: pointer;
  margin-right: 30px;
}
.tab-box::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  background: rgba(203, 180, 134, 1);
  border-radius: 50%;
  position: absolute;
  left: 0px;
  top: 39px;
}
.tab-text {
  width: 80%;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3d4652;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    color: rgba(203, 180, 134, 1);
  }
}
.tab-date {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bcbec0;
  padding-right: 58px;
  width: 146px;
  white-space: nowrap;
  text-align: right;
  &:hover {
    color: rgba(203, 180, 134, 1);
  }
}
.design-html{
  overflow: hidden;
  .img{
  // text-align: center !important;
  width: 90% !important;
  margin-bottom: 150px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/home/foreignCompanyService/swiper-content.vue